import React from "react";
import { DropdownChangeParams } from "primereact";
import { Input } from "../../../../components/form/formik/input/styles";
import { DropdownStyled } from "../../../../components/form-factory/styled";


type FiltersProps = {
  onSubmit: (value: any) => void
}

export const Filters = ({ onSubmit }: FiltersProps): JSX.Element => {
  const [filter, setFilter] = React.useState<any | undefined>({ hasRecurrence: "true" });
  const ref = React.useRef<NodeJS.Timeout | null>(null);

  const handleSubmit = (e: string): void => {
    setFilter((prev: any) => ({ ...prev, query: e }));


    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      onSubmit({ ...filter, query: e });
    }, 500);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span>Buscar:</span>
      <Input
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        placeholder="Busque por uma nota"
        value={filter?.query}
      />
      <DropdownStyled
        name="hasRecurrence"
        disabled={false}
        options={[
          { value: "true", label: "Ativas" },
          { value: "false", label: "Canceladas" },
        ]}
        placeholder="Status da recorrência"
        value={filter?.hasRecurrence}
        optionLabel="label"
        optionValue="value"
        emptyMessage="Nenhuma opção encontrada"
        style={{
          marginBottom: 0,
          width: "300px",
          marginLeft: "15px",
          color: "white",
        }}
        onChange={(e: DropdownChangeParams) => {
          const value = e.target.value === "true";
          setFilter((prev: any) => ({
            ...prev,
            hasRecurrence: e.target.value,
          }));

          onSubmit({ ...filter, hasRecurrence: value, page: 0 });
        }}
      />
    </div>
  );
};